<template>
  <div class="row event" :class="{ blocked: evt.block }">
    <div class="col-3" v-if="imageSrc">
        <img style="width: 100%;" :src="imageSrc" />
    </div>
    <div class="col">
      <a class="url" :href="url" target="_blank">{{url}}</a> // {{ evt.event_id }}
      <h5>
        {{ evt.event_name }}
      </h5>
      <div v-if="editKeywords" class="input-group">
        <input ref="keywords" type="text" class="form-control" v-model="newKeywords" @keyup.enter="onSubmitKeywords" @keydown.esc="onCancelKeywords"/>
        <div class="input-group-append">
          <button type="button" class="btn btn-outline-dark" @click="onCancelKeywords">cancel</button>
          <button type="button" class="btn btn-outline-dark" @click="onSubmitKeywords">submit</button>
        </div>
      </div>
      <div class="keywords" v-else >
        <h5 v-if="keywords"><span class="text-muted">Keywords: </span>{{ keywords }}</h5>
        <button type="button" class="btn btn-outline-dark btn-sm" @click="onEditKeywords">{{ keywords ? 'edit' : 'add' }} keywords</button>
      </div>
      <div>{{ evt.date }} {{ evt.time }}</div>
      <div v-if="evt.tags && evt.tags.length">Tags: <span v-for="(tag, i) in evt.tags" :key="tag+i"><template v-if="i>0"> / </template><b>{{tag}}</b></span></div>
      <div v-if="evt.details && evt.details['primary-entry']">Primary: <span v-for="(tag, i) in evt.details['primary-entry']" :key="tag+i"><template v-if="i>0"> / </template><b>{{tag}}</b></span></div>
      <div v-if="evt.details && evt.details['secondary-entry']">Secondary: <span v-for="(tag, i) in evt.details['secondary-entry']" :key="tag+i"><template v-if="i>0"> / </template><b>{{tag}}</b></span></div>
      <div>
        <template v-for="(value, key, i) in evt.details">
          <span v-if="key !== 'primary-entry' && key !== 'secondary-entry'" :key="key">
            {{key && key[0].toUpperCase() + key.slice(1)}}: <b>{{value}}</b>
            <template v-if="i < (Object.keys(evt.details).length - 1)"> |</template>
          </span>
        </template>
        <!-- Format: <b>{{ evt.format }}</b>
        | Type: <b>{{ evt.type }}</b>
        | Track: <b>{{ evt.track }}</b> -->
      </div>
      <div class="row">
        <div class="col">
          <div><a @click.prevent.stop="showRawJson = !showRawJson" href="#">*</a></div>
          <pre v-if="showRawJson">{{ evt }}</pre>
        </div>
      </div>
    </div>
    <div class="col-1">
      <button type="button" class="btn btn-danger btn-sm" @click.prevent.stop="onBlock">{{ evt.block ? 'unblock' : 'block' }}</button>
    </div>
  </div>
</template>

<script>
// import { nextTick } from 'vue'

export default {
  name: 'SxswEvent',
  components: {},
  props: {
    evt: Object,
    keywords: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showRawJson: false,
      newKeywords: '',
      editKeywords: false
    }
  },
  watch: {
    keywords (val, oldVal) {
      console.log(' watch keywords', val, oldVal)
      // if (val === oldVal) return
      // if (val) this.newKeywords = val
    }
  },
  computed: {
    url () {
      return this.evt.url // `https://schedule.sxsw.com${this.evt.sxswId}`
    },
    imageSrc () {
      if (this.evt.img) {
        return this.evt.img
      } else {
        return false
      }
    }
  },
  methods: {
    onBlock () {
      //console.log('BLOCK', this.evt.event_id)
      const sxswId = this.evt.event_id
      const block = ({}).hasOwnProperty.call(this.evt, 'block') ? !this.evt.block : true
      this.$socket.emit('/sxswscraper/block', { sxswId, block }, resp => {
        // console.log(resp)
      })
    },
    onEditKeywords () {
      this.editKeywords = true
      if (this.keywords) this.newKeywords = this.keywords
      this.$nextTick(() => {
        this.$refs.keywords.focus()
      })
    },
    onSubmitKeywords () {
      if (this.keywords !== this.newKeywords) {
        this.$socket.emit('/sxswscraper/keywords', { sxswId: this.evt.event_id, keywords: this.newKeywords })
      }
      this.editKeywords = false
    },
    onCancelKeywords () {
      this.editKeywords = false
      if (this.keywords) this.newKeywords = this.keywords
    }
  }

}
</script>
